import React from "react";
import "./style.css";
export default function Checkbox({ children }) {
  return <span className="label__span">{children}</span>;
}
